import React, { lazy } from 'react';
import { scrollToPurchase } from '../utils/checkout';
export function BonusesSection() {
  const bonuses = [{
    num: 1,
    title: '30 Sit-Snap-Shoot Cheat Sheets',
    img: 'https://cdn.magicpatterns.com/uploads/49zvbTkdjAqvHwwBQTgzBH/Untitled_design_(1).png',
    desc: '30 simple photo recipes you can follow step by step with your own dog.',
    value: '49'
  }, {
    num: 2,
    title: '7 Lightroom Editing Walkthroughs',
    img: 'https://cdn.magicpatterns.com/uploads/3NDmUJE4RXRqg5ohZ3mbCc/Untitled_design_(2).png',
    desc: 'Simple editing guidance to help you make your dog photos look cleaner, warmer, and more polished.',
    value: '69'
  }, {
    num: 3,
    title: 'Photo Settings & Setup Guide for 119 Dog Photos',
    img: 'https://cdn.magicpatterns.com/uploads/isApy6HmHRdLWE3CjxjeFD/Untitled_design_(3).png',
    desc: 'A practical reference guide showing you what setup, light, and phone mode work best for different kinds of dog photos.',
    value: '49'
  }];
  return <section className="bg-gradient-to-b from-[#1a1208] via-[#1f160c] to-[#1a1208] py-20 md:py-28 px-4 text-white" data-id="element-56">
      <div className="max-w-4xl mx-auto" data-id="element-57">
        {/* Section 17 — Bonuses Intro */}
        <div className="text-center mb-16" data-id="element-58">
          <p className="font-sans font-bold text-green-400 uppercase tracking-widest text-sm mb-3" data-id="element-59">
            BONUSES INCLUDED TODAY (At no extra cost)
          </p>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-soft-gold mb-4" data-id="element-60">
            🎁 Special Bonuses
          </h2>
        </div>

        {/* Sections 18–20 — Individual Bonuses */}
        <div className="space-y-12" data-id="element-61">
          {bonuses.map(bonus => <div key={bonus.num} className="bg-white/5 backdrop-blur-sm rounded-2xl border border-soft-gold/20 overflow-hidden relative" data-id="element-62">
              {/* FREE TODAY Badge */}
              <div className="absolute top-0 right-0 bg-green-600 text-white font-bold px-4 py-1.5 rounded-bl-lg rounded-tr-xl z-10 shadow-md" data-id="element-63">
                FREE TODAY
              </div>

              {/* Bonus header */}
              <div className="px-6 pt-8 md:px-8 md:pt-10 text-center" data-id="element-64">
                <div className="inline-block bg-white/10 rounded-full px-4 py-1 mb-4" data-id="element-65">
                  <p className="font-sans text-sm text-gray-300" data-id="element-66">
                    Value:{' '}
                    <span className="line-through text-red-400" data-id="element-67">
                      NZD ${bonus.value}
                    </span>{' '}
                    <span className="text-green-400 font-bold ml-2" data-id="element-68">
                      TODAY: FREE
                    </span>
                  </p>
                </div>
                <h3 className="font-serif text-2xl md:text-3xl font-bold text-soft-gold mb-2" data-id="element-69">
                  🎁 Bonus #{bonus.num}
                </h3>
                <h4 className="font-sans text-xl md:text-2xl font-bold text-white mb-6" data-id="element-70">
                  {bonus.title}
                </h4>
              </div>

              {/* Bonus description */}
              <div className="px-6 pb-6 md:px-8" data-id="element-71">
                <p className="font-sans text-base md:text-lg text-gray-300 leading-relaxed text-center max-w-lg mx-auto mb-8" data-id="element-72">
                  {bonus.desc}
                </p>
              </div>

              {/* Bonus image */}
              <div className="px-6 pb-8 md:px-8 md:pb-10 cursor-pointer group" onClick={scrollToPurchase} data-id="element-73">
                <a href="#purchase" onClick={scrollToPurchase} className="block" data-id="element-74">
                  <img src={bonus.img} alt={`Bonus ${bonus.num}: ${bonus.title}`} className="w-full max-w-md mx-auto rounded-xl shadow-lg transition-transform duration-300 group-hover:scale-[1.02]" loading="lazy" decoding="async" width={448} height={448} data-id="element-75" />
                </a>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}